import React from 'react';
import { FormHelperText, FormControlLabel, Switch } from "@material-ui/core";
import { useTranslation } from 'react-i18next'; // ✅ Import translation hook

export const renderSingleCheckboxField = ({ input, label, meta: { touched, error }, ...custom }) => {
    const { t } = useTranslation(); // ✅ Use the translation function

    const { name, onChange } = input;
    const inputValue = input.value || false;

    return (
        <div>
            <div>
                <FormControlLabel
                    key={`checkbox-${name}`}
                    control={
                        <Switch
                            color="primary"
                            type="checkbox"
                            name={`${name}`}
                            value={inputValue}
                            checked={!!inputValue}
                            onChange={onChange}
                        />
                    }
                    label={label}
                />
            </div>
            {touched && error && (
                <FormHelperText error>{t(error)}</FormHelperText> // ✅ Translate error key
            )}
        </div>
    );
};



//import React from 'react';
//import { FormHelperText, FormControlLabel, Switch } from "@material-ui/core";

//export const renderSingleCheckboxField = ({ input, label, meta: { touched, error }, ...custom }) => {

//    const { name, onChange } = input;
//    const inputValue = input.value || false;

//    return (
//        <div>
//            <div>
//                <FormControlLabel
//                    key={`checkbox-${name}`}
//                    control={
//                        <Switch
//                            color="primary"
//                            type="checkbox"
//                            name={`${name}`}
//                            value={inputValue}
//                            checked={!inputValue ? false : true}
//                            onChange={onChange}
//                        />
//                    }
//                    label={label}
//                />
//            </div>
//            <FormHelperText error={error && touched}>{touched && error}</FormHelperText>
//        </div>
//    );
//};